let inquiry = document.getElementById("ContactForm-inquiry"),
	userDetails = document.getElementById("user-details"),
	productDetails = document.getElementById("product-details"),
	submitButton = document.getElementById("submit");

inquiry.addEventListener("change", function(){
	switch (inquiry.value) {
		case "general inquiry":
			userDetails.style.display = "block";
			productDetails.style.display = "none";
			submitButton.style.display = "block";
			break;
		case "product question":
			userDetails.style.display = "block";
			productDetails.style.display = "block";
			submitButton.style.display = "block";
			break;
		default:
			break;
	}
});